import { APIModel } from '@shared/interfaces';

import { PollingStatus, StatusProvider } from '@/tax/models';

export class DocImport implements APIModel {
    id = -1;
    periodId = -1;
    folderId = -1;
    status: PollingStatus = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.periodId = data.period_id ?? -1;
        this.folderId = data.folder_id ?? -1;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        return this;
    }

    serialize(): any {
        return {
            'period_id': this.periodId,
            'folder_id': this.folderId,
        };
    }
}
